/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Injectable} from '@angular/core';
export class AriaService {
public ariaLabelledBy: string;
public ariaControls: string;
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function AriaService_tsickle_Closure_declarations() {
/** @type {?} */
AriaService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AriaService.ctorParameters;
/** @type {?} */
AriaService.prototype.ariaLabelledBy;
/** @type {?} */
AriaService.prototype.ariaControls;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
